import { Controller } from "remult";

@Controller("date-and-time-range-methods")
export class DateAndTimeRangeMethods {}
